var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 2.92282C23.1013 3.41055 22.148 3.73066 21.1719 3.87249C22.1887 3.12608 22.9693 1.9441 23.3369 0.535798C22.3704 1.23829 21.3129 1.73327 20.2103 1.99934C19.312 0.827243 18.0324 0.0947266 16.6162 0.0947266C13.8968 0.0947266 11.6921 2.79513 11.6921 6.12573C11.6921 6.5985 11.7357 7.05874 11.8196 7.50028C7.72744 7.24868 4.09931 4.84764 1.67072 1.19873C1.24697 2.08948 1.00416 3.12562 1.00416 4.23076C1.00416 6.32324 1.8735 8.16918 3.19462 9.25078C2.4127 9.22084 1.64797 8.96216 0.964313 8.49633C0.964063 8.5216 0.963969 8.5469 0.964031 8.57224C0.964031 11.4944 2.66128 13.932 4.91372 14.4861C4.18864 14.7276 3.42809 14.763 2.69016 14.5895C3.31669 16.9856 5.13516 18.7292 7.28972 18.778C5.60456 20.3955 3.48141 21.3598 1.17459 21.3598C0.777094 21.3598 0.385219 21.3312 0 21.2755C2.17903 22.9867 4.76719 23.9852 7.54781 23.9852C16.6047 23.9852 21.5573 14.795 21.5573 6.82518C21.5573 6.56359 21.5525 6.30349 21.543 6.04489C22.5069 5.19122 23.3389 4.13401 24 2.92282Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.63be8ab38efad6a88bd023a8086752ad.svg";
export { ForwardRef as ReactComponent };